import { render, staticRenderFns } from "./QTranslate.vue?vue&type=template&id=3d2efa16"
import script from "./QTranslate.vue?vue&type=script&lang=ts"
export * from "./QTranslate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports